import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(() => ({
  mainContainer: {
    background: "#F5F8FF",
    minHeight: "100%",
    minWidth: "100%",
    //position:"absolute",
    //bottom:"auto",
  },
  root: {
    padding: "20px 20px 0px 300px",
  },
  tableDiv: {
    border: "1px",
  },
  treatmentCell: {
    maxWidth: "300px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  filterSelect: {
    width: "200px",
    marginRight: 15,
    marginTop: 10,
    "& label": {
      marginBottom: "15px",
    },
    "& .css-jd1zyo-MuiSelect-select-MuiInputBase-input-MuiInput-input.MuiSelect-select":
      {
        background: "white",
        border: "1px solid #D1D1D1",
        borderRadius: "5px",
        height: "30px",
        marginTop: "8px",
        padding: "5px",
      },
    "& .css-175axk8-MuiInputBase-root-MuiInput-root:before, & .css-175axk8-MuiInputBase-root-MuiInput-root:after":
      {
        border: "none",
      },
  },
  clearFilter: {
    color: "#EDAC15",
    fontSize: 14,
    fontWeight: 400,
    cursor: "pointer",
  },
  dateDiv: {
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
  },
  dateDivRoot: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  page: {
    position: "relative",
  },
  filterContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: 50,
    marginBottom: 24,
  },
  ml25: {
    marginLeft: "25px !important",
  },
  search: {
    background: "#F5F5F5",
    border: "none",
    borderRadius: 7,
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  dataTableDiv: {
    maxHeight: "calc(100vh - 285px)",
    overflowY: "auto",
    overflowX: "auto",
    border: "1px solid #C6C9CA",
    marginTop: "0px",
    background: "#F5F8FF",
  },
  addBtn: {
    fontSize: 14,
    color: "#333333",
    border: "1px solid #D5D8DE",
    fontFamily: "Cairo",
    fontWeight: "400",
  },
  btnDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  datePicker1: {
    position: "absolute",
    opacity: 0,
    zIndex: -1,
    right: "200px",
  },
  datePicker: {
    position: "absolute",
    opacity: 0,
    zIndex: -1,
  },
  dateButton: {
    color: "#333333",
    border: "1px solid #D5D8DE",
    backgroundColor: "#F7F7FA",
    minWidth: "180px",
    fontSize: "14px",
    minHeight: "45px",
  },
  addModal: {
    position: "absolute",
    background: "#FFFFFF",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px",
    boxShadow: "0",
    zIndex: "9999",
    display: "flex",
  },
  deleteModal: {
    position: "absolute",
    background: "#FFFFFF",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    border: "0px",
    boxShadow: "0",
    zIndex: "9999",
    width: "410px",
    height: "230px",
  },
  modalContainer: {
    padding: "25px",
  },
  headerModal: {
    color: "#012497",
    fontFamily: "Cairo",
    fontWeight: "800",
    fontSize: "24px",
  },
  deleteTypo: {
    color: "#2A3333",
    fontFamily: "Cairo",
    fontWeight: "400",
    fontSize: "16px",
  },
  btnContainer: {
    display: "flex",
    alignItems: "flex-end",
  },
  cancelBtn: {
    color: "#3D63E6",
    borderColor: "#3D63E6",
    "&:hover": {
      borderColor: "#3D63E6",
    },
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: "16px",
    width: "160px",
    height: "50px",
  },
  saveBtn: {
    background: "#3D63E6",
    color: "#ffff",
    "&:hover": {
      background: "#3D63E6",
    },
    fontFamily: "Cairo",
    fontWeight: 700,
    fontSize: "16px",
    width: "160px",
    height: "50px",
  },
  textFieldStyle: {
    width: "200px",
    marginRight: 15,
    "& label": {
      marginBottom: "15px",
    },
    "& .css-jd1zyo-MuiSelect-select-MuiInputBase-input-MuiInput-input.MuiSelect-select":
      {
        background: "white",
        border: "1px solid #D1D1D1",
        borderRadius: "5px",
        height: "30px",
        marginTop: "8px",
        padding: "5px",
      },
    "& .css-175axk8-MuiInputBase-root-MuiInput-root:before, & .css-175axk8-MuiInputBase-root-MuiInput-root:after":
      {
        border: "none",
      },
  },
  statusTabs: {
    minHeight: "42px",
    borderBottom: "1px solid #C6C9CA",
    marginBottom: "16px",
    "& .MuiTabs-flexContainer": {
      gap: 0,
    },
  },
  statusTabIndicator: {
    backgroundColor: "#012397",
    height: "2px",
  },
  statusTab: {
    minHeight: "42px",
    minWidth: "100px",
    padding: "10px",
    fontFamily: "Cairo",
    fontSize: "16px",
    fontWeight: 600,
    color: "#2A3333",
    textTransform: "none",
    "&.Mui-selected": {
      color: "#012397",
      fontWeight: 700,
    },
  },
}));
